export const financialAidsFr = {
  title: "Aides financières",
  subtitle: "Aides financières pour vous accompagner dans cette piste d'action.",
  loading: "Chargement…",
  error: "Une erreur est survenue.",
  retry: "Réessayer",
  types: {
    grant: "Subvention",
    loan: "Prêt",
    tax_credit: "Crédit d'impôt",
    guarantee: "Garantie de prêt",
    other: "Autre",
  },
  directory: {
    heading: "Aides financières",
    help: "Aides financières proposées pour cette piste d'action.",
    resultCount_one: "{{count}} aide",
    resultCount_other: "{{count}} aides",
    favoriteCount_one: "{{count}} favori",
    favoriteCount_other: "{{count}} favoris",
    seeMore_one: "Voir {{count}} aide de plus",
    seeMore_other: "Voir {{count}} aides de plus",
    none: "Aucune aide financière n'est encore disponible pour cette piste d'action.",
    noneFiltered: "Aucune aide financière ne correspond aux filtres sélectionnés.",
    noFavorites:
      "Vous n'avez pas encore d'aide financière favorite pour cette piste d'action.",
    seeAll: "Voir toutes les aides financières",
    unavailable:
      "Les aides financières ne sont pas disponibles pour cette piste d'action.",
    actionRequired: {
      title: "Sélectionnez une piste d'action",
      help: "Les aides financières se consultent à partir d'une piste d'action de votre plan d'action.",
      goToPlans: "Aller au plan d'action",
    },
  },
  card: {
    viewSheet: "Voir la fiche",
    upTo: "Jusqu'à {{amount}}",
    from: "À partir de {{amount}}",
    amountTbd: "Montant à confirmer",
    until: "Jusqu'au {{date}}",
    fromDate: "À partir du {{date}}",
    always: "En tout temps",
    favorite: "Ajouter aux favoris",
    unfavorite: "Retirer des favoris",
  },
  detail: {
    title: "Fiche de l'aide financière",
    programNumber: "Programme n° {{number}}",
    organization: "Organisme",
    fundingTypes: "Types de financement",
    amounts: "Montants offerts",
    eligibility: "Période d'admissibilité",
    regions: "Régions associées",
    territories: "Territoires couverts",
    sectors: "Secteurs associés",
    contactPerson: "Personne-ressource",
    contactEmail: "Courriel",
    contactPhone: "Téléphone",
    extension: "poste {{ext}}",
    consult: "Consulter le programme",
  },
  filters: {
    sectorsServed: "Secteurs associés",
    companySizes: "Taille des entreprises",
    orgTypes: "Types d'organisation associés",
    heading: "Filtres",
    search: "Titre, organisme…",
    type: "Type de financement",
    regions: "Régions associées",
    minAmount: "Montant minimum",
    maxAmount: "Montant maximum",
    favoritesOnly: "Mes favoris seulement",
  },
  cell: {
    all: "Consulter les aides financières pour cette piste d'action",
    favorites: "Consulter vos aides financières favorites pour cette piste d'action",
  },
  admin: {
    title: "Gestion des aides financières",
    create: "Créer une aide financière",
    editAid: "Modifier l'aide financière",
    edit: "Modifier",
    delete: "Supprimer",
    save: "Enregistrer",
    cancel: "Annuler",
    empty: "Aucune aide financière.",
    countTotal_one: "{{count}} aide financière au total",
    countTotal_other: "{{count}} aides financières au total",
    linkChangeToValidate: "À valider",
    linkChangePending: "En attente",
    orderToValidate: "Ordre à valider",
    orderPending: "Ordre en attente",
    import: "Importer des aides financières",
    importActions: "Importer des associations",
    importCancelledReviews_one:
      "L'import a annulé 1 révision en cours : {{titles}}.",
    importCancelledReviews_other:
      "L'import a annulé {{count}} révisions en cours : {{titles}}.",
    imported:
      "Import terminé : {{created}} créée(s), {{updated}} mise(s) à jour, {{skipped}} ignorée(s).",
    actionsImported:
      "Import terminé : {{pairs}} association(s) appliquée(s) pour {{aids}} aide(s).",
    created: "Aide financière créée.",
    updated: "Aide financière mise à jour.",
    deleted: "Aide financière supprimée.",
    confirmDelete: "Supprimer cette aide financière ?",
    history: "Historique",
    actionCount_one: "{{count}} piste d'action",
    actionCount_other: "{{count}} pistes d'action",
    selectAllFundingTypes: "Tous les types de financement",
    selectAllTerritories: "Toutes les MRC",
    territoriesUnavailable:
      "La liste des MRC n'a pas pu être chargée. Les territoires déjà enregistrés restent affichés.",
    otherToggle: "Autre — précisez",
    // The same columns the Django back-office table sorts on, same wording.
    sort: {
      label: "Trier par",
      default: "Ordre par défaut",
      title: "Titre",
      organization: "Organisme",
      eligibility: "Admissibilité",
      status: "Statut",
      actions: "Pistes d'action",
      ascending: "Croissant",
      descending: "Décroissant",
    },
    status: {
      pending: "En attente",
      unassociated: "Non associé",
      inactive: "Inactif",
      expired: "Expiré",
      upcoming: "À venir",
      active: "Actif",
    },
    invalidPhone: "Le numéro de téléphone est invalide.",
    contactPerson: "Personne-ressource",
    contactPersonHint:
      "Personne à joindre au sujet du programme. Affichée sur la fiche de l'aide.",
    fields: {
      title: "Titre du programme",
      programNumber: "Numéro du programme",
      organization: "Organisme",
      fundingTypes: "Types de financement",
      amountMin: "Montant minimum",
      amountMax: "Montant maximum",
      amountDescription: "Précisions sur les montants",
      eligibilityStart: "Début de l'admissibilité",
      eligibilityEnd: "Fin de l'admissibilité",
      contactLastName: "Nom",
      contactFirstName: "Prénom",
      contactFunction: "Fonction",
      contactEmail: "Courriel",
      contactPhone: "Téléphone professionnel",
      contactExtension: "Poste",
      officialUrl: "Lien officiel",
      summary: "Résumé",
      isActive: "Actif",
      isInactive: "Inactif",
      territories: "Territoires (MRC)",
      territoriesHint:
        "MRC couvertes par l'aide, pour le classement par territoire. Une entreprise est rattachée à sa MRC par son adresse.",
      territoriesUnknown: "Hors catalogue",
      serviceRegions: "Régions associées",
      sectorsServed: "Secteurs desservis",
      companySizes: "Tailles d'entreprise desservies",
      organizationTypes: "Types d'organisation admissibles",
      serviceRegionsOther: "Autres régions couvertes",
      sectorsServedOther: "Autres secteurs visés",
      organizationTypesOther: "Autres types d'organisation admissibles",
      actions: "Pistes d'action associées",
    },
  },
  orgTypes: {
    self_employed: "Travailleur autonome",
    private: "Entreprise privée",
    cooperative: "Coopérative et entreprise collective",
    not_for_profit: "Organisme à but non lucratif",
    economical_development: "Organisme de développement économique",
    municipality: "Municipalité",
    other: "Autre",
  },
  linkOrder: {
    section: "Ordre des aides par piste d'action",
    sectionHint:
      "Chaque changement d'ordre doit être validé par un autre administrateur.",
    pending: "En attente",
    toValidate: "À valider",
    open: "Ordre des aides ({{count}})",
    title: "Ordre des aides financières",
    intro:
      "Glissez-déposez pour définir l'ordre d'affichage. Un autre administrateur devra valider le changement.",
    introMine:
      "Vous avez proposé ce changement. Un autre administrateur doit le valider — vous ne pouvez pas valider votre propre proposition.",
    introReview:
      "Vérifiez l'ordre proposé, puis approuvez-le ou faites une contre-proposition.",
    linkChangeWarning:
      "Un changement d'associations est en attente pour cette piste d'action : la liste pourrait encore gagner ou perdre un élément.",
    notVisible: "non visible",
    new: "nouveau",
    was: "était {{n}}",
    proposedBy: "Proposé par {{name}}",
    addedSince: "Ajouté depuis la proposition — placé à la fin",
    note: "Note",
    noteLabel: "Note — requise",
    notePlaceholder: "Justifiez votre contre-proposition…",
    propose: "Proposer l'ordre",
    approve: "Approuver",
    counter: "Contre-proposer",
    submitCounter: "Soumettre la contre-proposition",
    close: "Fermer",
  },
  linkChange: {
    // Parity with the Django back-office: same wording, same split between the
    // list's review modal and the edit form's decision controls.
    awaiting_one:
      "{{count}} aide financière a un changement de pistes d'action en attente de votre validation.",
    awaiting_other:
      "{{count}} aides financières ont un changement de pistes d'action en attente de votre validation.",
    openReview: "À valider",
    pendingOnly: "En attente de validation seulement",
    noneAwaiting: "Aucun changement en attente de validation.",
    reviewTitle: "Aides financières · à valider",
    reviewIntro: "Proposés par d'autres personnes.",
    reviewIntroOwn: "Vous ne pouvez pas valider vos propres propositions.",
    review: "Réviser",
    proposedBy: "Proposé par {{name}}",
    note: "Note",
    noteLabel: "Note — requise",
    notePlaceholder: "Justifiez votre contre-proposition…",
    noDifference: "Aucune différence détectée.",
    count_one: "{{count}} proposition",
    count_other: "{{count}} propositions",
    later: "Plus tard",
    approveAll: "Approuver tout",
    formPendingMine:
      "Vous avez proposé ce changement. Un autre administrateur doit le valider — vous ne pouvez pas valider votre propre proposition.",
    formPendingReview:
      "Vérifiez le changement proposé, puis approuvez-le ou faites une contre-proposition.",
    approve: "Approuver",
    counter: "Contre-proposer",
    cancelCounter: "Annuler la contre-proposition",
    submitCounter: "Soumettre la contre-proposition",
    saveOthers: "Enregistrer les autres champs",
    staged:
      "Le changement de pistes d'action est en attente de validation par un autre administrateur.",
    frozen:
      "Les pistes d'action n'ont pas été modifiées : un changement est déjà en attente de validation.",
    approved: "Changement de pistes d'action approuvé.",
    countered: "Contre-proposition enregistrée, en attente d'une autre personne.",
    noneToApprove: "Aucun changement à approuver.",
    approvedCount_one: "{{count}} changement de pistes d'action approuvé.",
    approvedCount_other: "{{count}} changements de pistes d'action approuvés.",
  },
  picker: {
    newLink: "nouvelle",
    lockedEmpty:
      "Aucune — l'aide n'aurait plus de piste d'action associée.",
    lockedHint: "Changement en attente de validation : la liste proposée est affichée et ne peut pas être modifiée.",
    add: "Ajouter des pistes d'action",
    hint:
      "Pistes d'action associées à cette aide, dans l'ordre du questionnaire. L'ordre d'affichage des aides se règle par piste d'action.",
    empty: "Aucune piste d'action associée pour l'instant.",
    remove: "Retirer",
    modalTitle: "Ajouter des pistes d'action",
    searchActions: "Rechercher une piste d'action…",
    allIssues: "Tous les enjeux",
    allGoals: "Tous les objectifs",
    searchIssue: "Rechercher un enjeu…",
    searchGoal: "Rechercher un objectif…",
    selectAll: "Tout sélectionner",
    confirm: "Confirmer la sélection",
    linkedTag: "associée",
    matchCount_one: "{{count}} piste d'action",
    matchCount_other: "{{count}} pistes d'action",
    selectedCount_one: "{{count}} sélectionnée",
    selectedCount_other: "{{count}} sélectionnées",
    noMatch: "Aucune piste d'action ne correspond.",
  },
};
